var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#B5B5B5"
    },
    width: 435.568,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.286,
    y: 7.752,
    style: {
      fill: "#26272B"
    },
    width: 384.284,
    height: 493.643
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.536,
    y: 53.052,
    style: {
      fill: "#545469"
    },
    width: 350.496,
    height: 112.659
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.204,
    y: 70.89,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.541,
    y: 70.89,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.878,
    y: 70.89,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.215,
    y: 70.89,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.551,
    y: 70.89,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.204,
    y: 119.083,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.541,
    y: 119.083,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.878,
    y: 119.083,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.215,
    y: 119.083,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.551,
    y: 119.083,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.536,
    y: 203.264,
    style: {
      fill: "#545469"
    },
    width: 350.496,
    height: 112.659
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.551,
    y: 221.102,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.215,
    y: 221.102,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.878,
    y: 221.102,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.541,
    y: 221.102,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.204,
    y: 221.102,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.551,
    y: 269.295,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.215,
    y: 269.295,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.878,
    y: 269.295,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.541,
    y: 269.295,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.204,
    y: 269.295,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.536,
    y: 343.463,
    style: {
      fill: "#545469"
    },
    width: 350.496,
    height: 112.659
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.204,
    y: 409.493,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.541,
    y: 409.493,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.878,
    y: 409.493,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.215,
    y: 409.493,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.551,
    y: 409.493,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.204,
    y: 361.3,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.541,
    y: 361.3,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.878,
    y: 361.3,
    style: {
      fill: "#CBDE80"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.215,
    y: 361.3,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.551,
    y: 361.3,
    style: {
      fill: "#649AA1"
    },
    width: 43.812,
    height: 28.791
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.745,
    y: 80.121,
    style: {
      fill: "#26272B"
    },
    width: 18.777,
    height: 45.064
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.168,
    y: 80.121,
    style: {
      fill: "#26272B"
    },
    width: 18.776,
    height: 45.064
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.745,
    y: 237.062,
    style: {
      fill: "#26272B"
    },
    width: 18.777,
    height: 45.064
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.168,
    y: 237.062,
    style: {
      fill: "#26272B"
    },
    width: 18.776,
    height: 45.064
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.745,
    y: 378.825,
    style: {
      fill: "#26272B"
    },
    width: 18.777,
    height: 45.064
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.168,
    y: 378.825,
    style: {
      fill: "#26272B"
    },
    width: 18.776,
    height: 45.064
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#040000"
    },
    points: "410.556,0.008 217.784,0.008 217.784,511.982 410.556,511.982 435.592,511.982 435.592,0.008 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.55b64350067ac54fa0033d61a807c631.svg";
export { ForwardRef as ReactComponent };